import api from './api';

export const authService = {
  // Seller registration
  registerSeller: async (userData) => {
    // Create FormData for multipart upload
    const formData = new FormData();
    
    // Add text fields
    Object.keys(userData).forEach(key => {
      if (key === 'aadhar_card_image' || key === 'pan_card_image') {
        // Handle file uploads
        if (userData[key] && userData[key] instanceof File) {
          formData.append(key, userData[key]);
        }
      } else {
        // Handle regular form fields
        formData.append(key, userData[key]);
      }
    });

    const response = await api.post('/api/auth/register/seller/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Login
  login: async (credentials) => {
    console.log('AuthService: Sending login request with:', credentials);
    const response = await api.post('/api/auth/login/', credentials);
    console.log('AuthService: Login response:', response.data);
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout
  logout: async () => {
    try {
      await api.post('/api/auth/logout/');
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
  },

  // Get profile
  getProfile: async () => {
    const response = await api.get('/api/auth/profile/');
    return response.data;
  },

  // Update profile
  updateProfile: async (profileData) => {
    const response = await api.patch('/api/auth/profile/update/', profileData);
    return response.data;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Get seller credits
  getSellerCredits: async () => {
    const response = await api.get('/api/auth/seller/credits/');
    return response.data;
  },

  // Get seller verification status
  getVerificationStatus: async () => {
    const response = await api.get('/api/auth/seller/verification-status/');
    return response.data;
  },

  // Google Authentication
  googleAuth: async (accessToken) => {
    console.log('AuthService: Sending Google auth request with token:', accessToken);
    const response = await api.post('/api/auth/auth/google/', {
      access_token: accessToken
    });
    console.log('AuthService: Google auth response:', response.data);
    
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  },

  // Google Registration for sellers
  googleRegister: async (accessToken, userData) => {
    // Create FormData for multipart upload
    const formData = new FormData();
    
    // Add access token and user type
    formData.append('access_token', accessToken);
    formData.append('user_type', 'seller');
    
    // Add other form data
    Object.keys(userData).forEach(key => {
      if (key === 'aadhar_card_image' || key === 'pan_card_image') {
        // Handle file uploads
        if (userData[key] && userData[key] instanceof File) {
          formData.append(key, userData[key]);
        }
      } else {
        // Handle regular form fields
        formData.append(key, userData[key]);
      }
    });

    const response = await api.post('/api/auth/auth/google/register/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  },

  // Check username availability
  checkUsernameAvailability: async (username) => {
    const response = await api.post('/api/auth/check-username/', {
      username: username
    });
    return response.data;
  }
};




